import React, { useState, MouseEvent } from "react"
import { useTranslation } from "react-i18next"
import { Typography, Menu, MenuItem, IconButton } from "@mui/material"
import TranslateIcon from "@mui/icons-material/Translate"

import { useAppDispatch, useAppSelector } from "redux/hooks"
import { selectSettingsById } from "redux/features/settings/settingsSlice"
import { updateClient } from "redux/features/client/clientThunk"
import { SettingsType } from "types"

type Props = {
  signedIn: boolean
}

const LanguageComponent = ({ signedIn }: Props) => {
  const dispatch = useAppDispatch()
  const { i18n } = useTranslation()

  const [anchorMenu, setAnchorMenu] = useState<null | HTMLElement>(null)

  const settings = useAppSelector(
    (state) => selectSettingsById(state, 0) as SettingsType,
  )

  const handleOpenMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorMenu(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setAnchorMenu(null)
  }

  const changeLanguage = (isoCode: string) => {
    if (signedIn) {
      dispatch(updateClient({ locale: isoCode }))
    }

    i18n.changeLanguage(isoCode)

    handleCloseMenu()
  }

  const languagesList = (settings?.languages || []).map((isoCode) => (
    <MenuItem
      key={isoCode}
      color="secondary"
      onClick={() => changeLanguage(isoCode)}
    >
      {i18n.t(`menu.language.${isoCode}`)}
    </MenuItem>
  ))

  return (
    <>
      {settings?.languages && (
        <>
          <IconButton disableRipple disableFocusRipple onClick={handleOpenMenu}>
            <TranslateIcon color="secondary" />
            <Typography color="secondary" component="span">
              {i18n.t(`menu.language.${i18n.language}`)}
            </Typography>
          </IconButton>
          <Menu
            id="language-menu"
            anchorEl={anchorMenu}
            keepMounted
            open={Boolean(anchorMenu)}
            onClose={handleCloseMenu}
          >
            {languagesList}
          </Menu>
        </>
      )}
    </>
  )
}

LanguageComponent.defaultProps = {
  light: false,
}

export default LanguageComponent
